<template>
  <ItemNotFoundState v-if="errorMessage" :objectName="$t('gamification.subject')">
    <template #backButton>
      <BackButton :target="{name: 'Subjects'}">{{ $t('gamification.subjects') }}</BackButton>
    </template>
  </ItemNotFoundState>
  <v-container v-else>
    <BackButton :target="{name: 'Subjects'}">{{ $t('gamification.subjects') }}</BackButton>
    <v-row>
      <v-col class="subjectName"> {{ this.subjectName }}</v-col>
      <v-col cols="auto">
        <primary-button @click="goToDetail"> {{ this.detailButtonName }}</primary-button>
      </v-col>
    </v-row>
    <v-tabs
        color="primary"
        stacked
        :model-value="tab"
        @update:model-value="tabChanged"
    >
      <v-tab value="seminar">
        <div class="d-flex flex-column align-center ga-2">
          <v-icon icon="co_present"/>
          {{ $t('gamification.seminars') }}
        </div>
      </v-tab>
      <v-tab value="tests">
        <div class="d-flex flex-column align-center ga-2">
          <v-icon icon="assignment_turned_in"/>
          {{ $t('gamification.tests') }}
        </div>
      </v-tab>
      <v-tab value="questions">
        <div class="d-flex flex-column align-center ga-2">
          <v-icon icon="forum"/>
          {{ $t('gamification.questions') }}
        </div>
      </v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item key="seminar" value="seminar">
        <Seminars/>
      </v-tabs-window-item>
      <v-tabs-window-item key="tests" value="tests">
        <Tests :subjectId="subjectId"/>
      </v-tabs-window-item>
      <v-tabs-window-item key="questions" value="questions">
        <Questions ref="questions_tab" :subjectId="subjectId"/>
      </v-tabs-window-item>
    </v-tabs-window>
  </v-container>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton";
import BackButton from "@/components/layout/BackButton";
import Tests from "@/views/Gamification/Tests";
import Questions from "@/views/Gamification/Questions";
import {mapActions, mapGetters} from "vuex";
import Seminars from "@/views/Gamification/Seminars.vue";
import ItemNotFoundState from "@/components/states/ItemNotFoundState.vue";


export default {
  name: "Gamification",
  components: {ItemNotFoundState, Seminars, Questions, Tests, BackButton, PrimaryButton},

  async mounted() {
    try {
      await this.fetchSubjectById(this.subjectId)
      this.errorMessage = null
    } catch (e) {
      console.log('error ', e)
      this.errorMessage = 'Chyba'
    }
  },
  created() {
    if (this.$query.tab) {
      this.tab = this.$query.tab
    } else {
      this.$query.tab = 'seminar'
      this.tab = 'seminar'
    }
  },

  data() {
    return {
      tab: "",
      errorMessage: null
    }
  },

  computed: {
    ...mapGetters('Subjects', ['getSubjectById']),
    subjectId() {
      return Number(this.$route.params.subjectId);
    },
    subjectName() {
      return this.getSubjectById(this.subjectId)?.name;
    },
    detailButtonName() {
      if (this.tab === 'seminar') {
        return this.$t('gamification.add_seminar')
      } else if (this.tab === 'tests') {
        return this.$t('gamification.add_test')
      } else if (this.tab === 'questions') {
        return this.$t('gamification.add_question')
      } else {
        return ''
      }
    }
  },

  methods: {
    ...mapActions('Subjects', ['fetchSubjectById']),

    tabChanged(value) {
      this.$query.tab = value
      this.tab = value
    },

    goToDetail() {
      if (this.tab === 'seminar') {
        this.goToSeminarDetail('new')
      } else if (this.tab === 'tests') {
        this.goToTestDetail('new')
      } else if (this.tab === 'questions') {
        this.$refs.questions_tab.openQuestionDialog(null)
      }
    },

    goToTestDetail(testId) {
      this.$router.push({
        name: 'TestDetail',
        params: {testId: testId, subjectId: this.subjectId}
      });
    },
    goToQuestionDetail(questionId) {
      this.$router.push({
        name: 'QuestionDetail',
        params: {questionId: questionId, subjectId: this.subjectId}
      });
    },

    goToSeminarDetail(seminarId) {
      this.$router.push({
        name: 'SeminarDetail',
        params: {seminarId: seminarId, subjectId: this.subjectId}
      })
    }

  }
}
</script>

<style scoped>

.subjectName {
  font-weight: 500 !important;
  font-size: 2rem;
  color: black;
  line-height: 1.2;
}

</style>